import {Select} from '@wandb/weave/components/Form/Select';
import React, {useRef, useState} from 'react';

import {TeamMemberRole} from '../TeamMembersTable/utils';
import {
  customSelectComponentForRoleOptions,
  RoleOption,
  TeamOrOrganizationRoleOption,
} from '../TeamOrOrganizationRoleOption';
import {OrganizationMemberRole} from '../util';

type Props = {
  roleOptions: RoleOption[];
  role: string;
  setRole: (role: OrganizationMemberRole | TeamMemberRole) => void;
};

export const RoleDropdown = ({roleOptions, role, setRole}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Select<RoleOption, false>
      menuIsOpen={isOpen}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      options={roleOptions}
      formatOptionLabel={option => (
        <TeamOrOrganizationRoleOption roleOption={option} />
      )}
      value={roleOptions.find(option => option.value === role)}
      onChange={selected => {
        if (selected?.value && !selected?.isDisabled) {
          setRole(selected.value as OrganizationMemberRole | TeamMemberRole);
        }
      }}
      components={customSelectComponentForRoleOptions(true)}
      menuPortalTarget={ref.current}
      menuPosition="fixed"
      isSearchable={false}
      isLoading={false}
      classNamePrefix="invite-role-dropdown-trigger"
    />
  );
};
